import Slider from "react-slick";


const SliderOnSale = ({items, children, styles, slidesToShow = 2.5}) => {
  let settings = {
    dots: false,
    infinite: false,
    speed: 200,
    slidesToShow: slidesToShow,
    slidesToScroll: 2,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return <Slider className={styles} {...settings}>
        {
          items.map((item) => {
            return children(item);
          })
        }
      </Slider>;
};

export default SliderOnSale;
